import { UserInterface } from '@/models/users/User.interface'
import { login as loginUser, logout as logoutUser } from '@/api_client'

// eslint-disable-next-line
const login = async (code: string) => {
  const user: UserInterface = await loginUser(code)
  user.email && localStorage.setItem('user', JSON.stringify(user))
}

const logout = async (apiCall = true) => {
  if (apiCall) await logoutUser()
  localStorage.removeItem('user')

  const cognitoLogoutUrl = process.env.VUE_APP_COGNITO_LOGOUT_URL
  if (cognitoLogoutUrl) {
    window.location.assign(cognitoLogoutUrl)
  }
}

const isLoggedIn = () => {
  const userData: string | null = localStorage.getItem('user')
  if (!userData) return false

  const user: UserInterface = JSON.parse(userData)
  return !!user.email
}

const setBackUrl = (url: string | null) => {
  url
    ? localStorage.setItem('backUrl', url)
    : localStorage.removeItem('backUrl')
}
const getBackUrl = (): string | null => localStorage.getItem('backUrl')

export const userService = {
  login,
  logout,
  isLoggedIn,
  setBackUrl,
  getBackUrl
}
